import React from 'react';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import base64 from 'base-64';

import MatchPaymentsTable from 'app/components/payments/MatchPaymentsTable';
import { IMatchPayment } from 'app/ducks/matchPayments/types';

import * as matchPaymentActions from 'app/ducks/matchPayments/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as matchPaymentsSelectors from 'app/ducks/matchPayments/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as competitionsSelectors from 'app/ducks/competitions/selectors';

interface IMatchPaymentsListProps {
  actions?: any;
  organisations?: any;
  competitions?: any;
  matchPayments?: any;
  match?: any;
  appReady?: boolean;
}

interface IMatchPaymentsListState {
  initialFilter: any;
  error?: string;
}

function selector(state) {
  return {
    matchPayments: matchPaymentsSelectors.getMatchPayments(state),
    organisations: organisationsSelectors.getOrganisations(state),
    competitions: competitionsSelectors.getCompetitions(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  matchPaymentActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class MatchPaymentsList extends React.Component<IMatchPaymentsListProps, IMatchPaymentsListState> {
  static defaultProps: IMatchPaymentsListProps = {
    actions: undefined,
    matchPayments: undefined,
    match: undefined,
    appReady: false,
  };

  // componentDidMount(): void {
  //   this.props.actions.getAllMatchPayments();
  // }

  render(): React.ReactNode {
    const filterConfig = this.props.match?.params?.filterConfig ? JSON.parse(base64.decode(this.props.match?.params?.filterConfig)) : {};
    const defaultSinceDate = new Date();
    defaultSinceDate.setDate(defaultSinceDate.getDate() - 3);
    const defaultUntilDate = new Date();
    defaultUntilDate.setDate(defaultUntilDate.getDate() + 7);

    const defaultRoundLocalAt = [defaultSinceDate, defaultUntilDate];
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Match Payments"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <MatchPaymentsTable
              {...this.props.matchPayments}
              competitions={this.props.competitions}
              appReady={this.props.appReady}
              actions={this.props.actions}
              match={this.props.match}
              saveFilters
              showChildren
              initialFilterConfig={!_.isEmpty(filterConfig) ? filterConfig : { roundLocalDateAt: defaultRoundLocalAt }}
              isLoading={this.props.matchPayments.isLoading}
              selectMatchPayment={this.props.actions.selectMatchPayment}
            />
          </div>
        </div>
      </div>
    );
  }
}
